import { Container, Dialog } from './components';

export const Floating = {
  Container,
  Dialog,
};
